<template>
  <div>
    <h2 class="page-title">
      <img
        :src="require(`@images/series/${$route.params.lang}/txt_series-${$route.params.seriesId}.png`)"
        class="page-title-text"
      >
    </h2>

    <div class="index-list-wrapper">
      <ul class="index-list">
        <index-item
          v-for="indexItem in indexList"
          :key="indexItem.key"
          :indexItem="indexItem"
          :selectedIndex="selectedIndex"
          @click="goToIndex"
        />
      </ul>
    </div>

    <div class="hero-list-wrapper">
      <div class="hero-list">
        <div
          v-for="indexHero in indexHeroList"
          :key="indexHero.indexId.key"
        >
          <div :id="indexHero.indexId ? `index-${indexHero.indexId.value}` : ''" />
          <hero-item
            v-for="(hero, index) in sortedHeroList(indexHero.heroList)"
            :key="index"
            :hero="hero"
            @goToIndex="goToIndex"
          />
        </div>
      </div>
    </div>

    <button @click="goToSeriesPage" class="button-back">
      <img
        :src="require(`@images/common/${$route.params.lang}/btn_back.png`)"
        height="112"
        width="108"
      >
    </button>
    <button @click="goToRandomPage" class="button-random">
      <img
        :src="require(`@images/series/${$route.params.lang}/btn_random.png`)"
        height="112"
        width="108"
      >
    </button>

  </div>
</template>

<script>
import Enum from 'enum'
import Api from '@libraries/api/'
import RequestHeroes from '@requests/heroes'
import { validatelocale } from '@constants'

import IndexItem from '@components/series/index-item'
import HeroItem from '@components/series/hero-item'

const INDEX_LIST_JA = new Enum({
  'AA':'a',
  'KA':'ka',
  'SA':'sa',
  'TA':'ta',
  'NA':'na',
  'HA':'ha',
  'MA':'ma',
  'YA':'ya',
  'RA':'ra',
  'WA':'wa',
  'WO':'wo',
  'NN':'n',
})
const INDEX_LIST_OTHER = new Enum({
  'A':'a',
  'B':'b',
  'C':'c',
  'D':'d',
  'E':'e',
  'F':'f',
  'G':'g',
  'H':'h',
  'I':'i',
  'J':'j',
  'K':'k',
  'L':'l',
  'M':'m',
  'N':'n',
  'O':'o',
  'P':'p',
  'Q':'q',
  'R':'r',
  'S':'s',
  'T':'t',
  'U':'u',
  'V':'v',
  'W':'w',
  'X':'x',
  'Y':'y',
  'Z':'z',
})

export default {
  name: 'heroes',
  components: {
    IndexItem,
    HeroItem,
  },
  data() {
    return {
      indexHeroList: [],
      selectedIndex: null,
      mainHeight: "100vh"
    }
  },
  created() {
    this.getHeroes(this.$route.params)
    this.mainHeight = window.innerHeight + "px";
  },
  watch: {
    '$route.params.lang'(){
      this.getHeroes(this.$route.params)
    }
  },
  computed: {
    indexList() {
      if (this.$route.params.lang === 'zh-TW') {
        return null
      } else {
        return this.indexHeroList? this.indexHeroList.map(h => h.indexId) : null
      }
    },
  },
  methods: {
    async getHeroes(params){
      const cookieCheck = await validatelocale(this.$route.params.lang)
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      if (cookieCheck) {
        Api.call(new RequestHeroes(params.seriesId, params.lang))
          .then((heroes) => {
            if (params.lang === 'ja-JP') {
              this.indexHeroList = heroes.map(h => {
                const indexId = INDEX_LIST_JA.enums.find(i => i.value === Object.keys(h)[0])
                return {
                  indexId: indexId,
                  heroList: Object.values(h)[0],
                }
              })
              this.selectedIndex = this.indexHeroList[0].indexId
            } else if (params.lang === 'zh-TW') {
              this.indexHeroList = heroes.map(h => {
                return {
                  indexId: '',
                  heroList: Object.values(h)[0],
                }
              })
              this.selectedIndex = null
            } else {
              this.indexHeroList = heroes.map(h => {
                const indexId = INDEX_LIST_OTHER.enums.find(i => i.key === Object.keys(h)[0])
                return {
                  indexId: indexId,
                  heroList: Object.values(h)[0],
                }
              })
              this.selectedIndex = this.indexHeroList[0].indexId
            }
          })
          .catch(({error}) => {
            throw error
          })
      } else {
        location.reload()
      }
    },
    sortedHeroList(heroes){
      if(this.$route.params.lang === 'zh-TW') return heroes
      const sorted = heroes.map(h => h).sort((a, b) => {
        if(this.$route.params.lang === 'ja-JP'){
          return a.kana.localeCompare(b.kana)
        }
        return a.name.localeCompare(b.name)
      })
      return sorted
    },
    goToIndex(index) {
      this.selectedIndex = index
      this.$scrollTo(`#index-${index.value}`, 400, {
        container: '.hero-list-wrapper',
        offset: -280,
      })
    },
    goToSeriesPage() {
      this.$router.push(`/${this.$route.params.lang}/series`)
      window.scrollTo(0, 0)
    },
    goToRandomPage() {
      this.$router.push(`/${this.$route.params.lang}/random`)
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-title {
  background-image: url(~@images/bg_page-title.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: 0 2px;
  height: 66px;
  width: 608px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  &-text {
    margin-top: -8px;
  }
}

.hero-list-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  .hero-list {
    padding: 280px 0 210px;
    &:after {
      content: '';
      display: block;
      background: linear-gradient(to right, rgba(95,255,255,1) 0%,rgba(95,255,255,0.7) 70%,rgba(95,255,255,0) 100%);
      height: 2px;
      width: 640px;
    }
  }
}

.index-list-wrapper {
  position: absolute;
  top: 180px;
  right: 35px;
  z-index: 1;
  width: 62px;
  min-height: 696px;
  height: calc(100% - 180px - 70px);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background: url(~@images/series/bg_series-index.png) repeat-y;
}

.index-list {
  padding: 150px 0;
}
.button-back,
.button-random {
  position: absolute;
  bottom: 92px;
  @include tap-event();
  z-index: 20;
}
.button-back {
  left: 23px;
}
.button-random {
  right: 12px;
}
</style>
